
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.058 7V5.5a2 2 0 00-2-2h-8a2 2 0 00-2 2v19a2 2 0 002 2h8a2 2 0 002-2V23","stroke":"#707070","stroke-miterlimit":"10"}}),_c('mask',{attrs:{"id":"a","fill":"#fff"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.558 7.5a1.5 1.5 0 00-1.5-1.5h-8a1.5 1.5 0 00-1.5 1.5v15a1.5 1.5 0 001.5 1.5h8a1.5 1.5 0 001.5-1.5h1a2.5 2.5 0 01-2.5 2.5h-8a2.5 2.5 0 01-2.5-2.5v-15a2.5 2.5 0 012.5-2.5h8a2.5 2.5 0 012.5 2.5h-1z"}})]),_c('path',{attrs:{"d":"M19.558 7.5v1h-1v-1h1zm0 15h-1v-1h1v1zm1 0v-1h1v1h-1zm0-15h1v1h-1v-1zm-2.5-2.5a2.5 2.5 0 012.5 2.5h-2a.5.5 0 00-.5-.5V5zm-8 0h8v2h-8V5zm-2.5 2.5a2.5 2.5 0 012.5-2.5v2a.5.5 0 00-.5.5h-2zm0 15v-15h2v15h-2zm2.5 2.5a2.5 2.5 0 01-2.5-2.5h2a.5.5 0 00.5.5v2zm8 0h-8v-2h8v2zm2.5-2.5a2.5 2.5 0 01-2.5 2.5v-2a.5.5 0 00.5-.5h2zm0 1h-1v-2h1v2zm-2.5.5a1.5 1.5 0 001.5-1.5h2a3.5 3.5 0 01-3.5 3.5v-2zm-8 0h8v2h-8v-2zm-1.5-1.5a1.5 1.5 0 001.5 1.5v2a3.5 3.5 0 01-3.5-3.5h2zm0-15v15h-2v-15h2zm1.5-1.5a1.5 1.5 0 00-1.5 1.5h-2a3.5 3.5 0 013.5-3.5v2zm8 0h-8V4h8v2zm1.5 1.5a1.5 1.5 0 00-1.5-1.5V4a3.5 3.5 0 013.5 3.5h-2zm0-1h1v2h-1v-2z","fill":"#707070","mask":"url(#a)"}}),_c('path',{attrs:{"d":"M11 9h13v13H11V9z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20 23a8 8 0 100-16 8 8 0 000 16z","fill":"#219653"}}),_c('path',{attrs:{"d":"M24 11.667l-5.667 6.666L16 16","stroke":"#fff","stroke-linecap":"round"}})])
          )
        }
      }
    